/**
 * Serializes values with stable object-key ordering for deterministic signatures.
 * Defaults to locale order to preserve existing fingerprints. New persistent hashes can opt
 * into code-unit order so their bytes do not depend on the host locale.
 */
export function stableStringify(
  value: unknown,
  keyOrder: "locale" | "code-unit" = "locale",
): string {
  if (Array.isArray(value)) {
    return `[${value.map((item) => stableStringify(item, keyOrder)).join(",")}]`;
  }

  if (value && typeof value === "object") {
    return `{${Object.entries(value)
      .filter(([, entryValue]) => entryValue !== undefined)
      .sort(([leftKey], [rightKey]) => {
        if (keyOrder === "locale") return leftKey.localeCompare(rightKey);
        return leftKey < rightKey ? -1 : 1;
      })
      .map(([key, entryValue]) => `${JSON.stringify(key)}:${stableStringify(entryValue, keyOrder)}`)
      .join(",")}}`;
  }

  return JSON.stringify(value);
}
